/* eslint-disable no-unused-expressions */
import React from "react";
import GlobalForm from "../../components/globalForm/GlobalForm";
import Loading from "../../components/shared/loading/Loading";
import { updateData } from "../../hooks/update";
import useFetch from "../../hooks/useFetch";

import { apiPath } from "../../utility/Constant";

const FooterPage = () => {
  const { footerApi } = apiPath;
  const [footer, footerLoading] = useFetch(footerApi);
  if (footerLoading) {
    return <Loading />;
  }
  const {
    logo,
    intro,
    phone,
    address,
    email,
    copyright,
    aboutLinks,
    socialLinks,
    contactUsBg,
    contactUsSubTitle,
    contactUsTitle,
    mapUrl,
    mapImg,
  } = footer;

  const aboutLinksData = [];
  aboutLinks.map((item, index) => {
    aboutLinksData.push({
      label: `About Links ${index}`,
      type: "text",
      name: "",
      defaultValue: item,
      required: false,
    });
  });

  const socialLinksData = [];
  socialLinks.map((item, index) => {
    socialLinksData.push({
      label: `Social Links ${index}`,
      type: "text",
      name: "",
      defaultValue: item,
    });
  });

  const data = [
    // {
    //   elementType: "file",
    //   label: "Footer Logo",
    //   type: "file",
    //   name: "logo",
    //   defaultValue: logo,
    //   required: true,
    // },
    {
      elementType: "textField",
      label: "Footer Intro",
      type: "Text",
      name: "intro",
      defaultValue: intro,
      required: false,
    },
  ];

  const multiDimensionalDataText = [
    {
      elementType: "nested",
      label: "Social Links",
      name: "socialLinks",
      multipleData: socialLinksData,
      multiple: true,
      required: false,
    },
    {
      elementType: "nestedText",
      label: "About Links",
      name: "aboutLinks",
      multipleData: aboutLinksData,
      multiple: true,
      required: false,
    },
  ];

  const contactData = [
    {
      elementType: "textField",
      label: "Copyright",
      type: "Text",
      name: "copyright",
      defaultValue: copyright,
      required: true,
    },
  ];

  const useData = data.concat(multiDimensionalDataText, contactData);

  const update = (data) => {
    updateData(footerApi, data);
  };

  return (
    <div>
      <GlobalForm
        data={useData}
        multiDimensionalDataText={multiDimensionalDataText}
        update={update}
      />
    </div>
  );
};

export default FooterPage;
